<div class="auth-container">
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <div class="gradient-orb gradient-orb-3"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card auth-card-wide">
     <div class="desk-page">
      <!-- Top bar: Brand + Theme-Toggle + Login-Link -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="../../../../../assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
          <span class="login">
            {{ "REG_LOGIN_LINK_PREFIX" | translate }}
            <a [routerLink]="['/login']">{{ "LOG_IN" | translate }}</a>
          </span>
        </div>
      </div>

      <ng-container *ngIf="!checkInboxEmail; else checkInboxView">
      <!-- Greeting -->
      <div class="desk-greet">
        <span class="greet-eyebrow">
          <span class="pulse"></span>
          {{ "REG_EYEBROW" | translate }}
        </span>
        <h1>
          {{ "REG_GREET_LINE_1" | translate }}
          <span class="grad">{{ "REG_GREET_BRAND" | translate }}</span>
          {{ "REG_GREET_LINE_2" | translate }}
        </h1>
      </div>

      <!-- Progress (2 steps, einheitlich für Web/Android/iOS – kein Tarifschritt mehr) -->
      <div
        class="desk-progress"
        role="list"
        [attr.aria-label]="'REG_STEP_1_LABEL' | translate"
      >
        <div class="progress-seg active" role="listitem">
          <div class="num">{{ "REG_STEP_1_NUM" | translate }}</div>
          <div class="label">{{ "REG_STEP_1_LABEL" | translate }}</div>
        </div>
        <div class="progress-seg" role="listitem">
          <div class="num">{{ "REG_STEP_2_NUM" | translate }}</div>
          <div class="label">{{ "REG_STEP_2_LABEL" | translate }}</div>
        </div>
      </div>

      <!-- Form -->
      <form
        [formGroup]="registerForm"
        autocomplete="off"
        novalidate
        (ngSubmit)="registerUser()"
        class="auth-form"
      >
        <!-- QA 1: Personal info -->
        <div class="desk-qa">
          <div class="qa-num">1</div>
          <div>
            <h3 class="qa-q" id="reg-qa1">{{ "REG_QA_1_Q" | translate }}</h3>

            <div class="xds-form-grid qa-fields">
              <!-- First name -->
              <xds-form-field
                labelKey="FIRST_NAME"
                [required]="true"
                for="reg-firstName"
                [invalid]="validateControl('firstName')"
                errorKey="FIRST_NAME_REQUIRED"
              >
                <xds-input
                  [id]="'reg-firstName'"
                  type="text"
                  formControlName="firstName"
                  [invalid]="validateControl('firstName')"
                  describedBy="reg-qa1"
                  (xdsBlur)="removeSpaces('firstName')"
                  placeholderKey="ENTER_FIRST_NAME"
                  iconLeft="fa-light fa-user"
                ></xds-input>
              </xds-form-field>

              <!-- Last name -->
              <xds-form-field
                labelKey="LAST_NAME"
                [required]="true"
                for="reg-lastName"
                [invalid]="validateControl('lastName')"
                errorKey="LAST_NAME_REQUIRED"
              >
                <xds-input
                  [id]="'reg-lastName'"
                  type="text"
                  formControlName="lastName"
                  [invalid]="validateControl('lastName')"
                  describedBy="reg-qa1"
                  (xdsBlur)="removeSpaces('lastName')"
                  placeholderKey="ENTER_LAST_NAME"
                  iconLeft="fa-light fa-user"
                ></xds-input>
              </xds-form-field>

              <!-- Company (full width) -->
              <xds-form-field
                class="xds-form-grid-full"
                labelKey="COMPANY"
                [required]="true"
                for="reg-companyName"
                [invalid]="validateControl('companyName')"
                errorKey="COMPANY NAME IS REQUIRED"
              >
                <xds-input
                  [id]="'reg-companyName'"
                  type="text"
                  formControlName="companyName"
                  [invalid]="validateControl('companyName')"
                  describedBy="reg-qa1"
                  placeholderKey="ENTER_COMPANY_NAME"
                  testId="register-company"
                  iconLeft="fa-light fa-building"
                ></xds-input>
              </xds-form-field>
            </div>
          </div>
        </div>

        <!-- QA 2: Login & security -->
        <div class="desk-qa">
          <div class="qa-num">2</div>
          <div>
            <h3 class="qa-q" id="reg-qa2">{{ "REG_QA_2_Q" | translate }}</h3>
            <p class="qa-hint">{{ "REG_QA_2_HINT" | translate }}</p>

            <div class="xds-form-stack">
              <!-- Email (full width) -->
              <div class="xds-form-grid qa-fields full">
                <xds-form-field
                  labelKey="EMAIL"
                  [required]="true"
                  for="reg-email"
                  [invalid]="validateControl('email')"
                  [errorKey]="hasError('email', 'email') ? 'PLEASE PROVIDE A VALID EMAIL' : 'EMAIL IS REQUIRED'"
                >
                  <xds-input
                    [id]="'reg-email'"
                    type="email"
                    formControlName="email"
                    [invalid]="validateControl('email')"
                    describedBy="reg-qa2"
                    (xdsBlur)="removeSpaces('email')"
                    placeholderKey="ENTER_EMAIL"
                    iconLeft="fa-light fa-envelope"
                    autocomplete="off"
                  ></xds-input>
                </xds-form-field>
              </div>

              <!-- Passwords (2 cols) -->
              <div class="xds-form-grid qa-fields">
                <xds-form-field
                  labelKey="PASSWORD"
                  [required]="true"
                  for="reg-password"
                  hintKey="REG_PW_LABEL_HINT"
                  hintIcon="fa-light fa-circle-info"
                  [invalid]="validateControl('password')"
                  [errorKey]="
                    hasError('password', 'required')
                      ? 'REG_PW_REQUIRED'
                      : 'REG_PW_POLICY_UNMET'
                  "
                >
                  <xds-input
                    [id]="'reg-password'"
                    [type]="showPassword ? 'text' : 'password'"
                    formControlName="password"
                    [invalid]="validateControl('password')"
                    describedBy="reg-qa2 reg-pw-line"
                    placeholderKey="ENTER YOUR PASSWORD"
                    testId="register-password"
                    autocomplete="new-password"
                  >
                    <ng-container ngProjectAs="[xdsInputTrailing]">
                      <xds-icon-button
                        [icon]="showPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
                        [ariaLabel]="(showPassword ? 'HIDE_PASSWORD' : 'SHOW_PASSWORD') | translate"
                        (clicked)="toggleShowPassword()"
                      ></xds-icon-button>
                    </ng-container>
                  </xds-input>
                </xds-form-field>

                <xds-form-field
                  labelKey="CONFIRM PASSWORD"
                  [required]="true"
                  for="reg-confirmPassword"
                  [invalid]="validateControl('confirmPassword')"
                  [errorKey]="hasError('confirmPassword', 'required') ? 'CONFIRMATION IS REQUIRED' : 'PASSWORDS MUST MATCH'"
                >
                  <xds-input
                    [id]="'reg-confirmPassword'"
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    formControlName="confirmPassword"
                    [invalid]="validateControl('confirmPassword')"
                    placeholderKey="REG_PW_REPEAT_PLACEHOLDER"
                    autocomplete="new-password"
                  >
                    <ng-container ngProjectAs="[xdsInputTrailing]">
                      <xds-icon-button
                        [icon]="showConfirmPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
                        [ariaLabel]="(showConfirmPassword ? 'HIDE_PASSWORD' : 'SHOW_PASSWORD') | translate"
                        (clicked)="toggleShowConfirmPassword()"
                      ></xds-icon-button>
                    </ng-container>
                  </xds-input>
                </xds-form-field>
              </div>
            </div>

            <!-- Password strength block (eigener margin-top in auth-shared.css, bewusst
                 AUSSERHALB des .xds-form-stack belassen — sonst doppelter Abstand) -->
            <div
              class="pw-block"
              *ngIf="registerForm.get('password')?.value"
              id="reg-pw-block"
            >
              <div
                class="pw-bars"
                [attr.data-strength]="getPasswordStrengthData()"
                aria-hidden="true"
              >
                <div class="seg" [class.on]="passwordStrength >= 1"></div>
                <div class="seg" [class.on]="passwordStrength >= 2"></div>
                <div class="seg" [class.on]="passwordStrength >= 3"></div>
                <div class="seg" [class.on]="passwordStrength >= 4"></div>
                <div class="seg" [class.on]="passwordStrength >= 5"></div>
              </div>
              <div class="pw-line" id="reg-pw-line" aria-live="polite">
                <span class="pw-status">
                  <span class="ico"><i class="fa-light fa-shield-halved"></i></span>
                  <span>{{ "REG_PW_STRENGTH_LABEL" | translate }}</span>
                </span>
                <span class="strong" *ngIf="passwordStrength === 5">
                  <span class="ico-ok"><i class="fa-solid fa-check"></i></span>
                  {{ getPasswordStrengthLabel() | translate }} · {{ passwordStrength }} / 5
                </span>
                <span class="level" *ngIf="passwordStrength < 5">
                  {{ getPasswordStrengthLabel() | translate }} · {{ passwordStrength }} / 5
                </span>
              </div>
              <div class="pw-checks">
                <span class="chk" [class.ok]="!hasError('password', 'minlength') && registerForm.get('password')?.value">
                  <i class="fa-light fa-check"></i>{{ "REG_PW_CHK_LENGTH" | translate }}
                </span>
                <span class="chk" [class.ok]="!hasError('password', 'missingUpper') && registerForm.get('password')?.value">
                  <i class="fa-light fa-check"></i>{{ "REG_PW_CHK_UPPER" | translate }}
                </span>
                <span class="chk" [class.ok]="!hasError('password', 'missingLower') && registerForm.get('password')?.value">
                  <i class="fa-light fa-check"></i>{{ "REG_PW_CHK_LOWER" | translate }}
                </span>
                <span class="chk" [class.ok]="!hasError('password', 'missingDigit') && registerForm.get('password')?.value">
                  <i class="fa-light fa-check"></i>{{ "REG_PW_CHK_DIGIT" | translate }}
                </span>
                <span class="chk" [class.ok]="!hasError('password', 'missingSpecial') && registerForm.get('password')?.value">
                  <i class="fa-light fa-check"></i>{{ "REG_PW_CHK_SPECIAL" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Vollzugriff-Testphase: KEINE Tarifwahl bei der Registrierung.
             Alle Funktionen sind während der Testphase frei; der Tarif wird erst später gewählt. -->
        <div class="desk-qa reg-trial" id="reg-trial-info">
          <div class="qa-num"><i class="fa-light fa-gift"></i></div>
          <div>
            <h3 class="qa-q">{{ "REG_TRIAL_TITLE" | translate }}</h3>
            <ul class="reg-trial-points">
              <li>
                <i class="fa-solid fa-check"></i>
                {{ 'REG_TRIAL_FULL_ACCESS' | translate:{ days: trialDays } }}
              </li>
              <li>
                <i class="fa-solid fa-check"></i>
                {{ "REG_TRIAL_NO_CC" | translate }}
              </li>
              <li>
                <i class="fa-solid fa-check"></i>
                {{ "REG_TRIAL_NO_RENEWAL" | translate }}
              </li>
              <li>
                <i class="fa-solid fa-check"></i>
                {{ "REG_TRIAL_CHOOSE_LATER" | translate }}
              </li>
            </ul>
          </div>
        </div>

        <!-- AGB akzeptieren (Vertrag) -->
        <div class="terms-inline">
          <xds-checkbox formControlName="termsAccepted" testId="register-terms">
            <span class="checkbox-label">
              {{ "GDPR_I_AGREE_TO" | translate }}
              <a
                href="https://fixplaner.com/nutzungsbedingungen"
                target="_blank"
                rel="noopener"
                class="link-text"
              >
                {{ "GDPR_TERMS_OF_SERVICE" | translate }}
              </a>
            </span>
          </xds-checkbox>
          <span
            class="error-message"
            *ngIf="
              registerForm.get('termsAccepted')?.invalid &&
              registerForm.get('termsAccepted')?.touched
            "
          >
            {{ "GDPR_TERMS_REQUIRED" | translate }}
          </span>
        </div>

        <!-- Datenschutz zur Kenntnis nehmen (Art. 13 DSGVO, keine Einwilligung) -->
        <div class="terms-inline">
          <xds-checkbox formControlName="privacyPolicyAccepted" testId="register-privacy">
            <span class="checkbox-label">
              {{ "GDPR_I_ACKNOWLEDGE" | translate }}
              <a
                href="https://fixplaner.com/datenschutz"
                target="_blank"
                rel="noopener"
                class="link-text"
              >
                {{ "GDPR_PRIVACY_POLICY" | translate }}
              </a>
              {{ "GDPR_PRIVACY_ACK_SUFFIX" | translate }}
            </span>
          </xds-checkbox>
          <span
            class="error-message"
            *ngIf="
              registerForm.get('privacyPolicyAccepted')?.invalid &&
              registerForm.get('privacyPolicyAccepted')?.touched
            "
          >
            {{ "GDPR_PRIVACY_REQUIRED" | translate }}
          </span>
        </div>

        <!-- Trust row (kompakt: nur 1 Zeile + Lock-Icon) -->
        <div class="trust-row desk-trust">
          <div class="ico-c"><i class="fa-light fa-shield-halved"></i></div>
          <div class="t1">{{ "REG_TRUST_T1" | translate }}</div>
        </div>

        <!-- Bot-Schutz: Cloudflare Turnstile (einwilligungsfrei, kein Tracking-Cookie) -->
        <div id="turnstile-container" class="turnstile-container"></div>

        <!-- Actions -->
        <div class="desk-actions">
          <!-- Button bleibt klickbar: unvollständiges Formular -> Inline-Fehler
               + Scroll/Fokus zum ersten fehlenden Feld statt wirkungslosem Klick.
               Bewusst OHNE [disabled]/[disabledReason] (beide würden den Klick blocken) -
               die "disabled"-Optik kommt rein über die is-incomplete-Klasse. -->
          <xds-button
            type="submit"
            variant="primary"
            iconRight="fa-light fa-arrow-right"
            [subdued]="!registerForm.valid || !captchaSolved"
            data-testid="register-submit"
          >
            {{ "REG_CTA_SUBMIT" | translate }}
          </xds-button>
          <p
            class="error-message submit-hint"
            aria-live="polite"
            *ngIf="submitAttempted && (!registerForm.valid || !captchaSolved)"
          >
            {{ "REG_SUBMIT_INCOMPLETE" | translate }}
          </p>
        </div>
      </form>
      </ng-container>

      <!-- FE-12 P5: nach Registrierung ohne Anmeldung — für neue und bekannte Adressen gleich -->
      <ng-template #checkInboxView>
        <div class="desk-greet check-inbox" role="status" data-testid="register-check-inbox">
          <h1 tabindex="-1">{{ "REGISTER_CHECK_INBOX" | translate }}</h1>
          <p class="check-inbox-hint">
            {{ "REGISTER_CHECK_INBOX_HINT" | translate: { email: checkInboxEmail } }}
          </p>
          <a [routerLink]="['/login']" data-testid="register-check-inbox-login">{{ "GO_TO_LOGIN" | translate }}</a>
        </div>
      </ng-template>
     </div>
    </div>
    <app-auth-legal-footer></app-auth-legal-footer>
  </div>
</div>
